import find from 'lodash/find';
import { CDN_ACCOUNT_TYPE , CURRENT_PRODUCT_MODE } from '@utils/constants';
import {
  isErrorCodeByMetric,
  getErrorCodeDimension,
  isErrorCodeByDimension,
} from './errorCodeHelper';

const DIMENSION_TABLE_LIMIT = 4;

const getExpectedDimensions = (customerAccountType) => {
  let EXPECTED_DEFAULT_DIMENSIONS = [];
  // default dimensions with fallback options
  // Customer Account Type 15 is for CDN Partners
  if (customerAccountType === CDN_ACCOUNT_TYPE) {
    EXPECTED_DEFAULT_DIMENSIONS = [
      ['CUSTOMER_ID'], // Customer ID
      ['GEO_ASN'], // ASN Number
      ['GEO_COUNTRY'], // Country
      ['m3.dv.n'], // Device Name
    ];
  } else {
    EXPECTED_DEFAULT_DIMENSIONS = {
      EI: [
        // channel, Asset Name
        ['channel', 'OBJECT_NAME'],
        // Device Name, Device Model, Players
        ['m3.dv.n', 'm3.dv.mod', 'c3.player.name', 'c3.device.model', 'c3.client.model'],
        ['GEO_DMA', 'GEO_CITY'], // DMA, City
        ['CDN'], // CDN
      ],
      AI: [
        // Asset Name, Ad Id, Ad creative Id, Ad System
        ['OBJECT_NAME', 'c3.ad.id', 'c3.ad.creativeId', 'c3.ad.system'],
        // Device Name, Device OS, Device Model
        ['m3.dv.n', 'm3.dv.osf', 'm3.dv.mod'],
        // DMA, State, Country
        ['GEO_DMA', 'GEO_STATE', 'GEO_COUNTRY'],
        // App Name, Player Name, Player Version, Device OS
        ['appName', 'c3.player.name', 'playerVersion', 'm3.dv.osf'],
      ],
      APP: [['app_id', 'platform', 'device_name', 'geo_country']],
    }[CURRENT_PRODUCT_MODE];
  }
  return EXPECTED_DEFAULT_DIMENSIONS;
};

export default (dimensionList, metricName, currentDimensions, customerAccountType) => {
  const defaultDimensions = [];
  let dimensionsLimit = DIMENSION_TABLE_LIMIT;

  if (isErrorCodeByMetric(metricName)) {
    defaultDimensions.push(getErrorCodeDimension(metricName));
    dimensionsLimit += 1; // extra Error Code dimension
  }

  // add all existing dimension, except error code dimension
  currentDimensions.forEach((dimension) => {
    if (!isErrorCodeByDimension(dimension) && find(dimensionList, ['name', dimension])) {
      defaultDimensions.push(dimension);
    }
  });

  // add pre-defined defaults
  if (defaultDimensions.length < dimensionsLimit) {
    const EXPECTED_DEFAULT_DIMENSIONS = getExpectedDimensions(customerAccountType);
    EXPECTED_DEFAULT_DIMENSIONS.forEach((candidates) => {
      for (let i = 0; i < candidates.length; i += 1) {
        const dimension = find(dimensionList, ['groupBy', candidates[i]]);
        if (dimension && !defaultDimensions.includes(dimension.name)) {
          defaultDimensions.push(dimension.name);
          break;
        }
      }
    });
  }

  // add available dimensions
  if (defaultDimensions.length < dimensionsLimit) {
    const dimensions = dimensionList.map((obj) => obj.name);
    const sliceLimit = dimensionsLimit - defaultDimensions.length;
    const filteredDimensions = dimensions
      .filter((dimension) => !defaultDimensions.includes(dimension))
      .slice(0, sliceLimit);
    defaultDimensions.push(...filteredDimensions);
  }

  return defaultDimensions.slice(0, dimensionsLimit);
};
